var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import { Redirect } from "react-router-dom";
import LoaderSplashScreen from "../loader/LoaderSplashScreen";
import CustomSwitch from "../routing/CustomSwitch";
import RouteGenerator from "../routing/RouteGenerator";
var BasePage = function () { return (_jsx(Suspense, __assign({ fallback: _jsx(LoaderSplashScreen, {}) }, { children: _jsxs(CustomSwitch, { children: [_jsx(Redirect, { exact: true, from: "/", to: "/dashboard" }), _jsx(RouteGenerator, {})] }) }))); };
export default BasePage;
